export const initialState = () => ({
  svaUuidEditing: false,
  svaAlreadyFetchEditing: false,
  svaName: "",
  svaPrice: "0,00",
  svaCategorySelected: "",
  svaScore: null,
  svaOptionsCategories: [],
  svaActive: false,
  svaIcon: [],
  svaIconPreview: {
    url: "",
    icon: ""
  },
  svaRelatedPlans: 0,

  svasOptions: [],
  svasSelecteds: []
})
